import React, { FC, useContext } from 'react';
import { MultiStatBlockStyled } from './styled';
import { Box, Icon, IconSize, Text, Theme, useMediaQuery, belowBreakpoint } from '@bechtel/gds';
import { ThemeContext } from 'styled-components';
import { StatsSpinner } from '@bechtel/client-common';
import { MultiStatBlockProps } from './types';

export const MultiStatBlock: FC<MultiStatBlockProps> = ({
  value,
  valueText,
  total,
  totalText,
  icon,
  loading,
  ...rest
}) => {
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  return (
    <MultiStatBlockStyled data-testid="multi-stat-block" {...rest}>
      <Box alignItems={{ sm: 'center' }} pb={{ sm: '100' }} justifyContent={{ sm: 'space-between' }}>
        <Box alignItems={{ sm: 'center' }}>
          {!loading ? (
            <Text
              data-testid="stat-block-value"
              size={isWideScreen ? '700' : '800'}
              color="grey.1000"
              family="graphik"
              weight="600"
            >
              {value}
            </Text>
          ) : (
            <StatsSpinner></StatsSpinner>
          )}
          <Box pt={{ sm: '200' }} pl={{ sm: '400' }}>
            {valueText && (
              <Text
                data-testid="stat-block-value-text"
                size={isWideScreen ? '200' : '300'}
                weight="600"
                color="grey.1000"
              >
                {valueText}
              </Text>
            )}
          </Box>
        </Box>
        {icon && (
          <Icon
            data-testid="stat-block-icon"
            icon={icon}
            size={isWideScreen ? IconSize.MEDIUM : IconSize.LARGE}
            fillColor="blue.800"
          />
        )}
      </Box>
      <Box mt={{ sm: '400' }} py={{ sm: '100' }} alignItems={{ sm: 'center' }}>
        {total &&
          (!loading ? (
            <Text size={isWideScreen ? '700' : '800'} weight="600" color="grey.1000" data-testid="stat-block-total">
              {total}
            </Text>
          ) : (
            <StatsSpinner></StatsSpinner>
          ))}
        {totalText && (
          <Box pl={{ sm: '400' }} pt={{ sm: '200' }}>
            <Text
              data-testid="stat-block-total-text"
              size={isWideScreen ? '200' : '300'}
              weight="600"
              color="grey.1000"
            >
              {totalText}
            </Text>
          </Box>
        )}
      </Box>
    </MultiStatBlockStyled>
  );
};
